import { AssetLocationMeta } from '/@/modules/asset/models/meta/AssetLocationMeta';
import { BelongingType } from '/@/modules/asset/enums/BelongingType';

export class BelongingAssetMeta extends AssetLocationMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {boolean}
   */
  isAppraised;

  /**
   * @var {?number}
   */
  purchasePrice;

  constructor(model = {}) {
    super(model);

    this.type = model.type;
    this.isAppraised = model.isAppraised;
    this.purchasePrice = model.purchasePrice;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return BelongingType.getByKey(this.type).value;
  }
}
